import { defineComponent as _defineComponent } from 'vue'
import SideNavbarComponent from "../components/side-navbar-component.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'navbar-component',
  setup(__props) {

const openNav = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  document!.getElementById("mySidenav")!.style.width = "100%";
};

const closeNav = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  document!.getElementById("mySidenav")!.style.width = "0";
};

return { __sfc: true,openNav, closeNav, SideNavbarComponent, store }
}

})